<template>
  <notes
    description="General Notes related to this Accommodation"
    :notableEntity="notableEntity"
  />
</template>
<script>
import notes from "@/components/Handi/Notes/Notes";

export default {
  props: {
    accom: Object
  },

  components: {
    notes
  },

  data() {
    return {
      entityType: "accommodation"
    };
  },

  computed: {
    notableEntity() {
      return {
        entityType: this.entityType,
        entityId: this.accom.id
      };
    }
  }
};
</script>
<style lang="scss" scoped></style>
